import script from "./Highlights.vue?vue&type=script&setup=true&lang=js"
export * from "./Highlights.vue?vue&type=script&setup=true&lang=js"

import "./Highlights.vue?vue&type=style&index=0&id=091f69c8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-091f69c8"]])

export default __exports__